module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_6000.e8eba31a.png";